import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getBankAccounts = createAsyncThunk(
  'bank/getBankAccounts',
  async ({ status }, { rejectWithValue }) => {
    try {
      const params = {};
      if (status) params.status = status;
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params,
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/bank-account`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const addNewBankAccount = createAsyncThunk(
  'bank/addNewBankAccount',
  async (data, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('account_name', data.account_name);
      formData.append('image', data.image);
      formData.append('bank_name', data.bank_name);
      formData.append('branch', data.branch);
      formData.append('account_number', data.account_number);
      formData.append('swift_code', data.swift_code);
      formData.append('branch_code', data.branch_code);
      formData.append('bank_address', data.bank_address);
      formData.append('currency', data.currency);
      formData.append('contact_number', data.contact_number);
      formData.append('reason_for_remittance', data.reason_for_remittance);

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      };

      const response = await axios.post(
        `${PUBLIC_BASE_URL}/bank-account/create-bank-account`,
        formData,
        config
      );

      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          message: 'Network Error',
          status: err.code,
          success: false,
        });
      } else {
        return rejectWithValue(err.response?.data || 'Unknown error occurred.');
      }
    }
  }
);

export const editBankAccount = createAsyncThunk(
  'bank/editBankAccount',
  async ({ bankData, file }, { rejectWithValue }) => {
    try {
      if (bankData.status !== undefined) {
        const config = {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        };

        const body = JSON.stringify(bankData);

        const response = await axios.put(`${PUBLIC_BASE_URL}/bank-account/update-bank-account-info`, body, config);
        return response.data;
      } else {
        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        };
        const formData = new FormData();

        const appendIfAvailable = (key, value) => {
          if (value !== null && value !== undefined && value !== "") {
            formData.append(key, value);
          }
        };

        appendIfAvailable("id", bankData.id);
        appendIfAvailable("account_name", bankData.account_name);
        appendIfAvailable("bank_name", bankData.bank_name);
        appendIfAvailable("branch", bankData.branch);
        appendIfAvailable("account_number", bankData.account_number);
        appendIfAvailable("swift_code", bankData.swift_code);
        appendIfAvailable("branch_code", bankData.branch_code);
        appendIfAvailable("bank_address", bankData.bank_address);
        appendIfAvailable("currency", bankData.currency);
        appendIfAvailable("contact_number", bankData.contact_number);
        appendIfAvailable("reason_for_remittance", bankData.reason_for_remittance);
        appendIfAvailable("status", bankData.status);
        appendIfAvailable("image", file);

        const response = await axios.put(`${PUBLIC_BASE_URL}/bank-account/update-bank-account-info`, formData, config);
        return response.data;
      }
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: err.code,
          success: false
        });
      } else {
        return rejectWithValue(err.response?.data || 'Unknown error occurred.');
      }
    }
  }
);